import React, { FC, useEffect, useRef } from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// nodejs library that concatenates classes
import classNames from "classnames";
import NumberFormat from "react-number-format";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import Input from "@material-ui/core/Input";
import InputAdornment from "@material-ui/core/InputAdornment";

// import styles from "assets/jss/chaintier/components/customInputStyle.js";

const NumberFormatCustom = React.forwardRef(function NumberFormatCustom(
  props,
  ref
) {
  const { onChange, ...other } = props;
  useEffect(() => {}, []);
  let intScale = props.intScale;
  const withValueCap = (inputObj) => {
    const { value } = inputObj;
    intScale = intScale ? intScale : 16;
    if (Number(value) < Math.pow(10, intScale)) {
      var array = value.toString().split(".");
      if (array[1]) {
        if (array[1].length < props.decimalScale2) {
          return inputObj;
        }
      } else {
        return inputObj;
      }
    }
  };

  return (
    <NumberFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      decimalScale={props.decimalScale}
      thousandSeparator
      isNumericString
      isAllowed={withValueCap}
      prefix=""
    />
  );
});
// const useStyles = makeStyles(styles);

export default function CustomInput(props) {
  const classes = {};
  const {
    value,
    set_value,
    type,
    disabled,
    readOnly,
    multiline,
    justWidth,
    autoComplete,
    endAdornment,
    formControlProps,
    labelText,
    id,
    labelProps,
    inputProps,
    error,
    white,
    inputRootCustomClasses,
    success,
    helperText,
    decimalScale,
  } = props;

  const labelClasses = classNames({
    [" " + classes.labelRootError]: error,
    [" " + classes.labelRootSuccess]: success && !error,
  });
  const underlineClasses = classNames({
    [classes.underlineError]: error,
    [classes.underlineSuccess]: success && !error,
    [classes.underline]: true,
    [classes.whiteUnderline]: white,
  });
  const marginTop = classNames({
    [inputRootCustomClasses]: inputRootCustomClasses !== undefined,
  });
  const inputClasses = classNames({
    [classes.input]: true,
    [classes.whiteInput]: white,
  });
  var formControlClasses;

  if (formControlProps !== undefined) {
    formControlClasses = classNames(
      formControlProps.className,
      classes.formControl
    );
  } else {
    formControlClasses = classes.formControl;
  }
  var helpTextClasses = classNames({
    [classes.labelRootError]: error,
    [classes.labelRootSuccess]: success && !error,
  });
  return (
    <FormControl
      {...formControlProps}
      fullWidth={!justWidth}
      className={formControlClasses}
    >
      {labelText !== undefined ? (
        <InputLabel
          // className={classes.labelRoot + " " + labelClasses}
          // htmlFor={id}
          // {...labelProps}
          className={`${classes.labelRoot} ${labelClasses} MuiFormLabel-root ${
            value ? "MuiInputLabel-shrink" : ""
          }`}
        >
          {labelText}
        </InputLabel>
      ) : null}
      <Input
        className={readOnly ? "MuiReadOnly" : ""}
        classes={{
          input: inputClasses,
          root: marginTop,
          disabled: classes.disabled,
          underline: underlineClasses,
        }}
        value={value}
        onChange={(e) => {
          set_value(e.target.value);
        }}
        id={id}
        type={type}
        disabled={disabled}
        readOnly={readOnly}
        multiline={multiline || readOnly}
        // inputComponent={NumberFormatCustom}
        inputProps={{
          decimalScale2: decimalScale,
          // intScale: intScale,
          readOnly: readOnly,
        }}
        autoComplete={autoComplete}
        endAdornment={
          endAdornment ? (
            <InputAdornment position="end">{endAdornment}</InputAdornment>
          ) : null
        }
        {...inputProps}
      />
      {helperText !== undefined ? (
        <FormHelperText id={id + "-text"} className={helpTextClasses}>
          {helperText}
        </FormHelperText>
      ) : null}
    </FormControl>
  );
}

CustomInput.propTypes = {
  labelText: PropTypes.node,
  labelProps: PropTypes.object,
  id: PropTypes.string,
  inputProps: PropTypes.object,
  formControlProps: PropTypes.object,
  inputRootCustomClasses: PropTypes.string,
  error: PropTypes.bool,
  success: PropTypes.bool,
  white: PropTypes.bool,
  helperText: PropTypes.node,
};
